/* 🤖 this file was generated by svg-to-ts */
export const matIconReplyAll: {
  name: 'reply-all';
  data: string;
} = {
  name: 'reply-all',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"/></svg>`
};
